import { IconButton, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../contextRow";
import { Position } from "../hooks/useGetPositionRows";
import IconType from "./IconType";

export default function Type({ type }: Position) {
	const { isCollapsed, actions } = useContext(Context);

	const { translate } = useLocales();

	return (
		<Stack alignItems='center' direction='row' gap={2} width={220}>
			<IconType type={type} />
			<Typography noWrap variant='subtitle2'>
				{translate(`demo.${type}`)}
			</Typography>
			<IconButton onClick={actions.onCollapse}>
				<Iconify
					color={isCollapsed ? "primary.main" : "text.secondary"}
					icon={!isCollapsed ? "ep:arrow-right-bold" : "ep:arrow-down-bold"}
					width={11}
				/>
			</IconButton>
		</Stack>
	);
}
